/**
 * Summer jobs are represented only via jobType (no separate isSummerJob flag).
 */

const SUMMER_JOB_TYPE_LOWERCASE = new Set(['summer job', 'kesätyö', 'sommarjobb']);

export function isSummerJobTypeValue(jobType?: string | null): boolean {
  if (!jobType || typeof jobType !== 'string') return false;
  return SUMMER_JOB_TYPE_LOWERCASE.has(jobType.trim().toLowerCase());
}

export type AppLocale = 'en' | 'fi' | 'sv';

/** Algolia `jobType` facet value for the active index locale. */
export function summerJobTypeFacetForLocale(locale: AppLocale): string {
  if (locale === 'fi') return 'Kesätyö';
  if (locale === 'sv') return 'Sommarjobb';
  return 'Summer Job';
}

export function inferAppLocaleFromPathname(pathname: string): AppLocale {
  const seg = (pathname || '').split('/').filter(Boolean)[0]?.toLowerCase();
  if (seg === 'fi' || seg === 'sv') return seg;
  return 'en';
}
